enum PharmacyExistsParameterType {
    Address,
    FaxNumber
}

interface DirectoryPharmacyFaxNumberExistsParameters {
    countryId: string;
    type: PharmacyExistsParameterType.FaxNumber;
    faxNumber: string;
    exceptPharmacyId?: string;
}

export { DirectoryPharmacyFaxNumberExistsParameters, PharmacyExistsParameterType };
